import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  bottom: 0; 
  width: 100%;
  margin-top: 60px;
  padding: 25px 0;
  background: #0B4682;
  border-top: 4px solid #F1CE3E;

  @media only screen and (max-width: 768px) {
    position: relative;
    margin: 0;
  }
`;

export const Text = styled.p`
  text-align: center;
  font-size: 1rem;
  color: #fff;
`;